import * as React from "react";
import {authorize} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {FalconNavigatorHeader, ICacheManager, ICustomerPortalService, Types} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import {ChangeCardForm} from "./ChangeCardForm";
import {Redirect} from "react-router";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";

interface IProps {
    match?: any
}

interface IState {
    addCardSuccess: boolean
    addCardCancelled: boolean
    adHocPaymentsAllowed: boolean
    verificationReceived: boolean
    isAnnualProduct: boolean
    isAnnualPayment: boolean
    redirectToRenewal: boolean
    renewalInteractionId?: string | null
    reuseCard: boolean
}

@authorize
export class ChangeCardPage extends React.Component<IProps, IState> {
    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;
    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    constructor(props: IProps) {
        super(props);

        this.state = {
            verificationReceived: false,
            addCardSuccess: false,
            addCardCancelled: false,
            adHocPaymentsAllowed: sessionStorage.getItem("Falcon_adHocPaymentsAllowed") === 'true',
            isAnnualProduct: sessionStorage.getItem("product") === "annualMotor",
            isAnnualPayment: sessionStorage.getItem("payment") === "annual",
            redirectToRenewal: sessionStorage.getItem("redirectJourney") === "renewal",
            renewalInteractionId:  sessionStorage.getItem("renewalInteraction") !== null ? sessionStorage.getItem("renewalInteraction"): "",
            reuseCard: sessionStorage.getItem("reuseCard") === 'true'
        };

        this.verifyNewCard = this.verifyNewCard.bind(this);
        this.verificationNeeded = this.verificationNeeded.bind(this);
    }

    public async componentDidMount() {
        this.pluginTemplates.setPageTitle("Change your payment card");
        this.cacheManager.clearCache("getPolicies");

        if (this.verificationNeeded()) {
            this.verifyNewCard(this.props.match.params.paymentReference);
        }
    }

    public render() {
        const {
            addCardSuccess,
            addCardCancelled,
            verificationReceived
        } = this.state;

        const annualPaymentPage: string = this.state.isAnnualPayment ? '/dashboard/annualPaymentHistory/' + this.props.match.params.policyNumber : `/dashboard/monthlyPaymentHistory/` + this.props.match.params.policyNumber;

        const annualRedirectPage: string = this.state.redirectToRenewal ? `/journey/show/product/AnnualMotorInsurance/process/renewal/viewAndEditRenewalProposalPage/${this.state.renewalInteractionId}` : annualPaymentPage;

        if (this.state.redirectToRenewal) {
            window.sessionStorage.setItem("renewalCardWasChanged", "true");
        }

        if ((addCardSuccess || addCardCancelled) ) {
            if (addCardSuccess) {
                window.sessionStorage.setItem("showPopup", "true");
                window.sessionStorage.setItem("referrerJourney", "addNewCard");
            }

            this.cacheManager.clearCache("getProfile");
            return <Redirect to={`${this.state.isAnnualProduct ? annualRedirectPage : '/dashboard/paymentHistory'}`}/>
        }

        // ensures there are no needless calls to payment gateway
        const showForm: boolean = !this.verificationNeeded() || !addCardSuccess;

        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="plugin">
                    <FalconNavigatorHeader
                        back={`${this.state.isAnnualProduct ? annualPaymentPage : '/dashboard/account/cardConsent'}`}
                        title="Change your payment card"
                    />
                    { showForm &&
                        <ChangeCardForm
                            adHocPaymentsAllowed={this.state.adHocPaymentsAllowed}
                            verifyNewCardFailed={this.verificationNeeded() && verificationReceived && !addCardSuccess}
                            policyNumber={this.props.match.params.policyNumber}
                            />
                    }
                    {this.pluginTemplates.renderBackReloadLink("Back", false, `${this.state.isAnnualProduct ? annualPaymentPage : '/dashboard/account/cardConsent'}`)}
                </div>
                <FalconFooter/>
            </React.Fragment>
        );
    }

    private async verifyNewCard(paymentReference: string): Promise<void> {
        const reuseCardStatus: boolean = this.state.isAnnualProduct ? this.state.reuseCard : this.state.adHocPaymentsAllowed;
        const observable = await this.customerPortalService
            .verifyNewCard(paymentReference, reuseCardStatus, this.state.isAnnualProduct, this.props.match.params.policyNumber)
            .toPromise();

        this.setState({
            addCardSuccess: observable && observable.successful,
            addCardCancelled: observable && observable.cancelled,
            verificationReceived: true
        })
    }

    private verificationNeeded(): boolean {
        return this.props.match.params.paymentReference;
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/changeCard/ChangeCardPage.tsx